import { render, staticRenderFns } from "./Idle.vue?vue&type=template&id=21027ba4&"
import script from "./Idle.vue?vue&type=script&lang=js&"
export * from "./Idle.vue?vue&type=script&lang=js&"
import style0 from "./Idle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports